import {
    BASE_URL
} from '../../config';
import {
    GENERATE_GIFT_CARDS,
    GET_GIFT_CARD,
    UPDATE_GIFT_CARD,
    DELETE_GIFT_CARD,
    MARK_GIFT_CARD_AS_PRINTED,
    OPEN_GIFT_CARD_MODAL,
    CLOSE_GIFT_CARD_MODAL
} from './giftCard.actionsTypes';

import axios from 'axios';

export const getGiftCards = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}giftCard/`)
            .then((response) => {
                if (response.data) {
                    return dispatch({
                        type: GET_GIFT_CARD,
                        giftCards: response.data
                    });
                }
            });
    };
};

export const createGiftCards = (giftCardData, callback) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}giftCard/create`, { params: giftCardData })
            .then((response) => {
                if (callback) {
                    callback(response.data);
                }
                return dispatch({
                    type: GENERATE_GIFT_CARDS,
                    generatedCards: response.data
                });
            });
    };
};

export const updateGiftCard = (id, giftCardData, callback) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}giftCard/${id}`, giftCardData)
            .then((response) => {
                callback(response.data);
                return dispatch({
                    type: UPDATE_GIFT_CARD,
                    giftCard: response.data
                });
            });
    };

};

export const updateGiftCards = (giftCard) => {
    giftCard.cards.map(card => {
        const cardData = { ...giftCard };
        delete cardData.cards;
        axios.put(`${BASE_URL}giftCard/${card.id}`, { ...cardData, cardId: card.id })
            .then((response) => {
            })
    });
};

export const deleteGiftCard = (options, callback) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}giftCard/delete`, options)
            .then((response) => {
                callback(response.data);
                return dispatch({
                    type: DELETE_GIFT_CARD,
                    options: options
                });
            });
    };

};

export const markAsPrinted = (options, callback) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}giftCard/printed`, options)
            .then((response) => {
                callback(response.data);
                return dispatch({
                    type: MARK_GIFT_CARD_AS_PRINTED,
                    options: options
                });
            });
    };

};

export const openGiftCardModal = (giftCard) => {
    return {
        type: OPEN_GIFT_CARD_MODAL,
        giftCard
    };
};

export const hideGiftCardModal = () => {
    return {
        type: CLOSE_GIFT_CARD_MODAL
    };
};